

























































































































import moment from 'moment'
import VueI18n from 'vue-i18n'
import { Component, Prop, Vue } from 'vue-property-decorator'

import Accordion from '../../../../components/Accordion/Accordion.vue'
import { StepUnitAlias } from '../../../../components/PeriodSimplifier/types'
import { Product } from '../../../../components/Shop/Products/types'
import { PostState } from '../types'
import TelegramPostPreview from './TelegramPostPreview.vue'
import { isPostPinned, isPostWithDisableNotify, isPostWithProtectContent } from "./includes/helpers";
import { PostPreviewData } from './types'

@Component({
  data() {
    return {
      PostState
    }
  },
  components: {
    TelegramPostPreview,
    Accordion
  },
  methods: {
    isPostPinned,
    isPostWithDisableNotify,
    isPostWithProtectContent,
    moment
  }
})
export default class TgPostPreview extends Vue {
  @Prop() getPostInfo!: () => Promise<PostPreviewData | void> | undefined

  @Prop() getPostPreview!: () => Promise<void>

  @Prop() products!: Array<Product>

  @Prop() targetToUpload!: string

  @Prop() i18n!: VueI18n

  @Prop({ type: Boolean, required: false, default: false }) showIntervalValue!: boolean

  postData: PostPreviewData | null = null

  postLoading = false

  postRuntimes: Array<string> = []

  loadMoreRunTimes() {
    const existedLength = this.postRuntimes.length

    if (this.postData) {
      this.postRuntimes.push(...this.postData.post.run_time.slice(existedLength, existedLength + 100))
    }
  }

  get accordionTitle() {
    if (this.showIntervalValue) {
      return `${ this.$t('field_post_interval_title') }: ${ this.periodUnit }`
    }

    return this.$t('field_post_interval_title').toString()
  }

  get periodUnit(): any {
    if (this.postData && this.postData.post.schedule && this.postData.post.schedule.period) {
      const period = this.postData.post.schedule.period

      if (period.interval) {
        switch (period.unit as StepUnitAlias) {
          case StepUnitAlias.SECONDS:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_seconds', period.interval) }`
          case StepUnitAlias.MINUTES:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_minutes', period.interval) }`
          case StepUnitAlias.HOURS:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_hours', period.interval) }`
          case StepUnitAlias.DAYS:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_days', period.interval) }`
          case StepUnitAlias.WEEKS:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_weeks', period.interval) }`
          case StepUnitAlias.MONTHS:
            return `${ period.interval } ${ this.$tc('post_info_recurrent_unit_months', period.interval) }`
          default:
            return period.interval
        }
      }
    }

    return ''
  }

  resolvePostInfo() {
    const postInfo = this.getPostInfo()

    if (postInfo instanceof Promise) {
      postInfo
        .then((res) => {
          if (res) {
            this.postData = res

            if (Array.isArray(this.postData.post.run_time)) {
              this.postRuntimes = this.postData.post.run_time.slice(0, 100)
            } else {
              this.postRuntimes = [ this.postData.post.run_time ]
            }
          }
        })
        .finally(() => {
          this.postLoading = false
        })
    } else {
      this.postLoading = false
    }
  }

  created() {
    this.postLoading = true

    this.resolvePostInfo()
  }
}
